export * from './FormHeading';
export { default } from './FormHeading';
